<template>
  <v-form ref="p2Form" v-model="p2Form" lazy-validation>
    <v-container>
      <v-card class="UserGridlist" flat>
        <v-card-text>
          <v-row>
            <v-col>
              <v-form ref="tableForm" v-model="tableForm" lazy-validation>
                <ryou-table
                  ref="ryouTable"
                  :rowKey="rowKey"
                  :headers="headers"
                  :queryParams="queryParam"
                  :url="url"
                  :businessKey="businessKey"
                  :dummy="false"
                  :height="height"
                  :handleEdit="handleEdit"
                  :handleDelete="handleDelete"
                >
                  <v-row slot="filterContainer">
                    <v-col cols="1"></v-col>
                    <v-col cols="4">
                      <v-row class="pa-6">
                        <ryou-input
                          v-model="idFilterValue"
                          :value="idFilterValue"
                          :label="'ユーザID'"
                        >
                        </ryou-input>
                      </v-row>
                    </v-col>
                    <v-col cols="4" class="UserAddBtn">
                      <ryou-blue-btn
                        :label="'新規追加'"
                        :handlerClick="handleAdd"
                      >
                      </ryou-blue-btn>
                    </v-col>
                  </v-row>
                </ryou-table>
              </v-form>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <simple-dialog ref="modalForm" @ok="modalFormOk" :url="url">
      </simple-dialog>
    </v-container>
  </v-form>
</template>

<script>
import RyouInput from "@/components/formInput/RyouInput.vue";
import RyouBlueBtn from "@/components/formInput/RyouBlueBtn.vue";
import RyouTable from "@/components/table/RyouTable.vue";
import { RyouTableMixins } from "@/mixins/RyouTableMixins";
import SimpleDialog from "./modules/SimpleDialog.vue";

export default {
  name: "DormitoryUserListSimple",
  mixins: [RyouTableMixins],
  components: {
    RyouInput,
    RyouBlueBtn,
    RyouTable,
    SimpleDialog,
  },
  data() {
    return {
      p2Form: true,
      inputRulesFile: [],
      valid: true,
      search: "",
      rowKey: "rowIndex",
      businessKey: "user_id",
      tableForm: true,
      idFilterValue: "",
      height: 578,
      headers: [
        {
          text: "ユーザID",
          value: "user_id",
          width: "33%",
          sortable: true,
          groupable: false,
          filter: this.idFilter,
        },
        {
          text: "操作",
          class: "blue lighten-2 title",
          value: "actions",
          align: "center",
          sortable: false,
          groupable: false,
        },
      ],
      url: {
        originlist: "/dormitoryUser/dormitoryListGet/",
        add: "dormitorySimpleUser/insertUser",
        update: "dormitorySimpleUser/updateUser",
        delete: "dormitorySimpleUser/deleteUser",
      },
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      var that = this;
      if (
        this.$route.params.user_id != null &&
        this.$route.params.user_id != ""
      ) {
        that.url.list =
          that.url.originlist +
          this.$route.params.user_id +
          "/" +
          0 +
          "/" +
          "999";
      } else {
        if (that.$store.getters.getUserClass == "1") {
          that.url.list = that.url.originlist + " " + "/" + 0 + "/" + "999";
        } else {
          that.url.list =
            that.url.originlist +
            that.$store.getters.getUserId +
            "/" +
            0 +
            "/" +
            that.$store.getters.getUserClass;
        }
      }
    },
    //検索
    idFilter(value) {
      if (!this.idFilterValue) {
        return true;
      } else {
        // console.log("error");
      }
      return value.toLowerCase().includes(this.idFilterValue.toLowerCase());
    },
  },
  //computed: {
  //    showbtn() {
  //        if (this.$store.getters.getUserClass == "1") {
  //            return true;
  //        } else {
  //            return false;
  //        }
  //    },
  //},
};
</script>

<style scoped>
.UserAddBtn {
  padding-top: 30px;
  text-align: right;
}
</style>
